module.exports = __webpack_public_path__ + "static/media/cabinet-filing.f4ae99d2.svg";